import { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
export function useTierPromotionCardCtaType(deviation) {
    var _deviation_tier;
    const { isUserSubscribed, isOwner } = useSubscriptionTier(deviation);
    const isMobile = useContext(MobileContext);
    if (isOwner) {
        if (isMobile) {
            return;
        }
        return 'edit';
    }
    if (isUserSubscribed) {
        return 'view-subscribed';
    }
    if (!((_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.canUserSubscribe)) {
        return 'disabled';
    }
    return 'subscribe';
}
